var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMounted)?_c('vue-apex-charts',{attrs:{"width":"100%","type":"line","options":_vm.options,"series":_vm.series,"height":"350px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }